module.exports = __webpack_public_path__ + "static/img/dc-logo-powered-by-white.9fac8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dc-logo-powered-by-white.png
// module id = 2498
// module chunks = 0